import moment, { Moment } from "moment";

const getShippingType = (shippingType: string, orderDate: Moment, deliveryDate: Moment) => {
    let deliveryType = '';
    let calculatedDeliveryDate: Moment;
    let shippingIconUrl: string = '';

    if (shippingType === 'Pick A Day') {
        deliveryType = 'Just Say When';
        shippingIconUrl = '/images/icon-track-order-jsw.svg';
        calculatedDeliveryDate = moment(deliveryDate);
    } else if (shippingType === 'Same Day') {
        // within 2 hours should always be same day delivery
        deliveryType = 'Same Day';
        calculatedDeliveryDate = orderDate;
        shippingIconUrl = '/images/icon-track-order-jsw.svg';
    } else if (shippingType === 'Supplier') {
        deliveryType = 'Supplier';
        // add 10 days to this type of delivery
        calculatedDeliveryDate = orderDate.add(10, 'days');
        shippingIconUrl = '/images/icon-track-order-truck.svg';
    } else if (shippingType === 'Standard') {
        // add 10 days to this type of delivery
        deliveryType = 'Standard';
        calculatedDeliveryDate = orderDate.add(10, 'days');
        shippingIconUrl = '/images/icon-track-order-truck.svg';
    } else {
        deliveryType = shippingType;
        calculatedDeliveryDate = orderDate;
        shippingIconUrl = '/images/icon-track-order-truck.svg';
    }

    return {
        deliveryType,
        calculatedDeliveryDate,
        shippingIconUrl
    }
}

export { 
    getShippingType
}